import {ModuleWithProviders} from "@angular/core"
import {Routes, RouterModule} from '@angular/router';
import {ClientesFornecedoresListComponent} from './list/clientesfornecedores.list.component'
import {ClientesFornecedoresEditorComponent} from './editor/clientesfornecedores.editor.component'


export const routes: Routes = [
  {
    path: '', redirectTo: 'list', pathMatch: 'full'
  },
  {
    path: 'list',
    component:ClientesFornecedoresListComponent,
  },
  {
    path: 'edit',
    component:ClientesFornecedoresEditorComponent,
  },
  {
    path: 'edit/:id',
    component:ClientesFornecedoresEditorComponent,
  }
];

export const routing = RouterModule.forChild(routes);
